<template lang="pug">
Card.card.project-outlay(v-if="report != undefined")
    template(#title) {{ $t('projectOutlay.title', { periodYrs: report.savingsInPeriod.periodYrs }) }}
    template(#content)
        .estimated-costs
        div.estimated-costs-row
            div.title {{ $t('projectOutlay.grossMonthlyOutlay') }}
            div.amount.amount-value {{ formatNumberToString(report.estimatedMonthlyCostInPeriod) }}
        div.estimated-costs-row
            div.title {{ $t('projectOutlay.energySavings') }}
            div.amount.amount-value {{ formatNumberToString(report.savingsInPeriod.estimatedMonthlySavings) }}
        div.estimated-costs-row
            div.title {{ $t('projectOutlay.netCosts') }}
            div.amount.amount-value {{ formatNumberToString(report.estimatedNetMonthlyCostInPeriod) }}
</template>
<script lang="ts">
import { formatNumberToString } from "@/helpers";
import { useRecommendations } from "@/store/recommendations";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
export default defineComponent({
  name: "ProjectOutlayCard",
  components: {
    Card,
  },
  setup() {
    const { report } = storeToRefs(useRecommendations());
    return {
      report,
      formatNumberToString,
    };
  },
});
</script>
<style scoped lang="scss">
.project-outlay {
  cursor: default;
}
.estimated-costs-row {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
</style>
